// 物件情報表示用
const PropertyInfo = {
  namespaced: true,

  state: {
    info: {
      buildingName: '',
      buildingId: null,
      createdAt: '',
      createdShop: '',
      updatedAt: '',
      updatedPerson: '',
      roomNo: '',
      address: '',
      buildYear: '',
    },
  },
  getters: {
    getInfo: state => {
      return state.info
    },
  },
  mutations: {
    setInfo(state, info) {
      state.info = info
    },
  },
  actions: {},
}

export default PropertyInfo
